/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/practiceMode/practiceModeConsts.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/practiceMode/practiceModeConsts.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/practiceMode/practiceModeConsts.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const SALES_WORKSPACE_ACADEMY_SHORT_ID = 2639660;

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/practiceMode/practiceModeConsts.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const CREATE_LEADS_ACADEMY_SHORT_ID = 4784785;

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/practiceMode/practiceModeConsts.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const LANDING_PAGES_SHORT_ID_QA = 1000628;

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/practiceMode/practiceModeConsts.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const HOW_TO_SET_UP_THE_SALES_WORKSPACE_SHORT_ID = 3492097;

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/practiceMode/practiceModeConsts.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const PRACTICE_MODE_CONFIG = {
  [SALES_WORKSPACE_ACADEMY_SHORT_ID]: {
    toolPath: 'prospecting',
    upgradePoint: 'sales-workspace-academy',
    scope: 'prospecting-workspace-access'
  },
  [CREATE_LEADS_ACADEMY_SHORT_ID]: {
    toolPath: 'prospecting',
    upgradePoint: 'create-leads-academy',
    scope: 'prospecting-workspace-access'
  },
  [LANDING_PAGES_SHORT_ID_QA]: {
    toolPath: 'prospecting',
    upgradePoint: 'sales-workspace-academy',
    scope: 'prospecting-workspace-access'
  },
  [HOW_TO_SET_UP_THE_SALES_WORKSPACE_SHORT_ID]: {
    toolPath: 'prospecting',
    upgradePoint: 'sales-workspace-academy',
    scope: 'prospecting-workspace-access'
  }
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/practiceMode/practiceModeConsts.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const SHORT_IDS_PRACTICE_MODE_QA = [LANDING_PAGES_SHORT_ID_QA];

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/practiceMode/practiceModeConsts.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const SHORT_IDS_PRACTICE_MODE_PROD = [SALES_WORKSPACE_ACADEMY_SHORT_ID, CREATE_LEADS_ACADEMY_SHORT_ID, HOW_TO_SET_UP_THE_SALES_WORKSPACE_SHORT_ID];

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/practiceMode/practiceModeConsts.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const getPracticeModeConfig = shortId => {
  return PRACTICE_MODE_CONFIG[shortId] || null;
};